import { Component, OnInit, ViewChild } from '@angular/core';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Router } from '@angular/router';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { catchError, EMPTY, firstValueFrom, Observable, Subject, switchMap, tap } from 'rxjs';
import { MatTable, MatTableDataSource as MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CalendarComponent } from '../calendar/calendar.component';
import { UserDTO } from 'src/app/interfaces/user';
import { CalendarIntegrationDTO } from 'src/app/interfaces/calendarIntegration';
import { CalendarDTO } from 'src/app/interfaces/calendar';
import { CalendarService } from 'src/app/services/calendar.service';
import { CalendarIntegrationService } from 'src/app/services/calendar-integration.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgForOf, NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-calendars',
  imports: [ MatTable, MatOptionModule, MatSelectModule, FormsModule, MatCheckboxModule, NgIf, MatTableModule, NgForOf, MatFormFieldModule, MatInputModule
  ],
  templateUrl: './calendars.component.html',
  styleUrls: ['./calendars.component.css'],
})
export class CalendarsComponent implements OnInit {

  user: UserDTO;
  isOk: boolean = false;
  isLoggedIn = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  calendarIntegrations: CalendarIntegrationDTO[] = [];
  calendarIntegration: CalendarIntegrationDTO;
  calendar: CalendarDTO;
  calendars: CalendarDTO[] = [];
  displayedColumns: string[] = ['Summary', 'Show in Yournotes', 'Sync Remarkable', 'Foldername Remarkable'];
  dataSource = new MatTableDataSource<CalendarDTO>();
  rowSpan: number = 1;
  rowCount: number = 2;
  rowHeight: number = 70;
  screenHeight: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  constructor(private calendarIntegrationService: CalendarIntegrationService, private calendarService: CalendarService, private router: Router, 
    public matDialog: MatDialog, private tokenStorageService: TokenStorageService, public functions: FunctionsService) { }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.isOk = true;
    }
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
    this.getData().subscribe();
    this.determineRowSpan();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  determineRowSpan() {
    this.screenHeight = window.innerHeight;
    this.screenHeight = this.screenHeight - (this.rowCount * this.rowHeight);
    this.rowSpan = Math.floor(this.screenHeight / this.rowHeight);
  }

  getData(): Observable<any> {
    return this.calendarService.getCalendar(this.user.calendarId).pipe(
      tap({
        next: (data: any) => {
          this.calendar = data;
        }
      }),

      switchMap(() => {
        return this.calendarIntegrationService.getCalendarIntegration(this.calendar.calendarIntegrationId);
      }),

      tap({
        next: (data: any) => {
          this.calendarIntegration = data;
        }
      }),

      switchMap(() => {
        return this.calendarIntegrationService.getCalendarIntegrations();
      }),

      tap({
        next: (data: any) => {
          this.calendarIntegrations = data;
          this.calendarIntegrations.forEach(element => {
            if (element.id == this.calendarIntegration.id) {
              this.changeCalendarIntegration(element);
            }
          });
        }
      }),

      catchError(error => {
        console.error("One of the API calls failed:", error);
        return EMPTY; // stop the stream
      })

    );

  }

  async changeCalendarIntegration(calendarIntegration: CalendarIntegrationDTO) {
    this.calendarIntegration = calendarIntegration;
    this.calendars = await firstValueFrom(this.calendarService.getCalendars(calendarIntegration.id, false));
    this.dataSource.data = this.calendars;
  }

  openCalendarModal(row) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.data = row;
    dialogConfig.height = "295px";
    dialogConfig.width = "576px";
    const modalDialog = this.matDialog.open(CalendarComponent, dialogConfig);
    modalDialog.afterClosed().subscribe(data => {
      this.removeFromList(data, this.calendars, true);
    });
  }

  removeFromList(changedCalendar: CalendarDTO, calendars: CalendarDTO[], replace: boolean) {
    if (changedCalendar != null && calendars != null) {
      var index = calendars.findIndex(x => x.id == changedCalendar.id);
      if (index > -1) {
        if (replace) {
          calendars.splice(index, 1, changedCalendar);
        } else {
          calendars.splice(index, 1);
        }
      }
    }
  }

}
